import { Container, Row } from "react-bootstrap";

const NoMatch = () => {
  return (
    <Container fluid>
      <Row>
        <h1>Page not found.</h1>
      </Row>
    </Container>
  );
};

export default NoMatch;
